/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateView = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateView"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillOpacity={0.01}
        d="M34.44 49.86c-11.36 0-22.16-4.93-29.63-13.52L3.38 34.7l1.43-1.64a39.4 39.4 0 0 1 13.92-10.22l-3.54-8.44 4.61-1.93 3.63 8.66c2.77-.81 5.62-1.31 8.51-1.5v-9.1h5v9.1c2.75.17 5.46.63 8.1 1.37l3.58-8.53 4.61 1.93-3.47 8.27c5.49 2.33 10.4 5.89 14.31 10.38l1.43 1.64-1.43 1.64a39.26 39.26 0 0 1-29.63 13.52z"
      />
      <path
        fill="#F4F4F5"
        fillRule="evenodd"
        d="M34.44 22.05c-11.08 0-21 4.91-27.74 12.66 6.74 7.75 16.66 12.66 27.74 12.66s21-4.91 27.74-12.66c-6.74-7.75-16.66-12.66-27.74-12.66"
        clipRule="evenodd"
      />
      <path
        fill="#5E737D"
        d="M62.56 34.38A37.2 37.2 0 0 0 47.13 23.8l3.49-8.31-.92-.39-3.5 8.36c-3.59-1.2-7.38-1.84-11.24-1.89v-9.03h-1v9.03c-4.01.05-7.93.75-11.64 2.03l-3.57-8.5-.92.39 3.55 8.46A37.25 37.25 0 0 0 6.35 34.39l-.29.33.29.33a37.27 37.27 0 0 0 28.12 12.83c10.78 0 21.03-4.68 28.12-12.83l.29-.33-.29-.33zM34.44 46.86c-10.34 0-20.19-4.42-27.07-12.16a36.27 36.27 0 0 1 27.07-12.16c10.34 0 20.19 4.42 27.07 12.16a36.27 36.27 0 0 1-27.07 12.16"
      />
      <path
        fill="#5E737D"
        d="M34.44 43.55a8.84 8.84 0 1 0 0-17.68 8.84 8.84 0 0 0 0 17.68"
      />
    </svg>
  );
};
export default IllustrationEmptyStateView;
